/**
 * @fileoverview Utility for extracting the subdomain from a hostname.
 *
 * Provides a function to determine the subdomain portion of a hostname
 * relative to a specified base domain.
 */

/**
 * Extracts the subdomain from a given hostname relative to a base domain.
 *
 * @param {string} hostname - The full hostname (e.g., "app.example.com").
 * @param {string} baseDomain - The base domain to compare against (e.g., "example.com").
 * @returns {string | null} The subdomain if present, otherwise null.
 *
 * Examples:
 *   getCurrentSubdomain("app.example.com", "example.com") // "app"
 *   getCurrentSubdomain("example.com", "example.com") // null
 *   getCurrentSubdomain("foo.bar.example.com", "example.com") // "foo"
 */
export function getCurrentSubdomain(hostname: string, baseDomain: string): string | null {
  if (hostname === baseDomain) return null
  if (hostname.endsWith(`.${baseDomain}`)) {
    const left = hostname.slice(0, -(baseDomain.length + 1))
    const firstLabel = left.split('.')[0]
    return firstLabel || null
  }
  const labels = hostname.split('.')
  return labels.length >= 3 ? labels[0] : null
}
